import { useId, useRef, type FC } from "react";

import { type PropsWithClassName } from "@/components/podkit/lib/cn";

export const RustRoverLogo: FC<PropsWithClassName> = ({ className }) => {
    const id = useRef(useId()).current;

    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask id={`mask0_${id}`} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <path d="M0.13636 0.136353H23.8636V23.8636H0.13636V0.136353Z" fill="white" />
            </mask>
            <g mask={`url(#mask0_${id})`}>
                <path
                    d="M16.5085 0.136353L23.3149 5.00551L16.3232 14.136L9.65948 6.42821L16.5085 0.136353Z"
                    fill={`url(#paint0_linear_${id})`}
                />
                <path
                    d="M16.5085 0.136353L23.3149 5.00551L14.5057 9.08274L9.65948 6.42821L16.5085 0.136353Z"
                    fill={`url(#paint1_linear_${id})`}
                />
                <path
                    d="M16.5085 0.136353L14.5057 9.08274L9.65948 6.42821L16.5085 0.136353Z"
                    fill={`url(#paint2_linear_${id})`}
                />
                <path
                    d="M23.8636 14.7187L14.5544 9.01318L2.77702 17.3199L5.56046 22.6746L23.8636 14.7187Z"
                    fill={`url(#paint3_linear_${id})`}
                />
                <path
                    d="M23.8636 14.7186L18.455 11.4277L11.9839 13.1028L5.63761 23.8636L23.8636 14.7186Z"
                    fill={`url(#paint4_linear_${id})`}
                />
                <path
                    d="M18.3826 11.4465L23.8636 14.7185L15.838 14.8257L18.3826 11.4465Z"
                    fill={`url(#paint5_linear_${id})`}
                />
                <path
                    d="M13.1428 12.7515L8.17745 22.6267L15.8381 14.8258L13.1428 12.7515Z"
                    fill={`url(#paint6_linear_${id})`}
                />
                <path
                    d="M5.26253 0.305298L17.807 3.40729L5.63761 23.8637L0.13636 14.9994L5.26253 0.305298Z"
                    fill={`url(#paint7_linear_${id})`}
                />
                <path
                    d="M17.807 3.40723L12.5073 6.9291L5.63182 23.6828L5.87508 23.4645L8.17742 22.6267L17.807 3.40723Z"
                    fill={`url(#paint8_linear_${id})`}
                />
                <path
                    d="M5.26254 0.305298L13.9775 2.46324L10.7153 5.43435L5.26254 0.305298Z"
                    fill={`url(#paint9_linear_${id})`}
                />
                <path
                    d="M17.807 3.40725L13.9721 2.45898L13.9775 2.46317L10.7153 5.43424L12.3169 7.02484L17.807 3.40725Z"
                    fill={`url(#paint10_linear_${id})`}
                />
                <path
                    d="M5.63183 23.6826L0.13636 14.9993L10.7155 5.4342L12.317 7.02479L5.63183 23.6826Z"
                    fill={`url(#paint11_linear_${id})`}
                />
                <path
                    d="M5.63183 23.6826L0.13636 14.9993L10.7155 5.4342L12.317 7.02479L5.63183 23.6826Z"
                    fill={`url(#paint12_linear_${id})`}
                />
                <path
                    d="M5.63183 23.6826L0.13636 14.9993L10.7155 5.4342L12.317 7.02479L5.63183 23.6826Z"
                    fill={`url(#paint13_linear_${id})`}
                />
                <path
                    d="M5.26253 0.305298L0.13636 14.9993L10.7153 5.43428L5.26253 0.305298Z"
                    fill={`url(#paint14_linear_${id})`}
                />
                <path
                    d="M13.1551 12.7354L18.428 11.3872L14.9058 9.21362L13.1551 12.7354Z"
                    fill={`url(#paint15_linear_${id})`}
                />
            </g>
            <path d="M19.3636 4.63635H4.63636V19.3636H19.3636V4.63635Z" fill={`url(#paint16_linear_${id})`} />
            <mask id={`mask1_${id}`} maskUnits="userSpaceOnUse" x="4" y="4" width="16" height="16">
                <path d="M4.63636 4.63635H19.3636V19.3636H4.63636V4.63635Z" fill="white" />
            </mask>
            <g mask={`url(#mask1_${id})`}>
                <g opacity="0.3">
                    <path
                        opacity="0.5"
                        d="M19.3636 4.63635H11.788L5.81953 12.5956L16.2934 14.2315L19.3636 10.222V4.63635Z"
                        fill={`url(#paint17_linear_${id})`}
                    />
                    <path
                        d="M14.7066 19.3636L19.3636 17.0269V12.1219L18.4105 11.5419L11.984 13.2054L8.35213 19.3636H14.7066Z"
                        fill={`url(#paint18_linear_${id})`}
                    />
                    <path
                        d="M17.1366 4.63635H4.63636V19.3636H8.37544L17.1366 4.63635Z"
                        fill={`url(#paint19_linear_${id})`}
                    />
                </g>
            </g>
            <path d="M11.9898 16.592H6.45679V17.5125H11.9898V16.592Z" fill="white" />
            <path
                d="M6.47727 6.41589H9.07915C9.79254 6.41589 10.3591 6.62573 10.7368 6.98243C11.0515 7.29718 11.2195 7.73782 11.2195 8.28337V8.30435C11.2195 9.22764 10.7159 9.79413 10.0024 10.0669L11.3873 12.1022H9.91844L8.70146 10.2768H7.71526V12.1022H6.47727V6.41589ZM8.99522 9.1856C9.60375 9.1856 9.96048 8.87089 9.96048 8.38828V8.3673C9.96048 7.82174 9.58278 7.54897 8.97424 7.54897H7.73625V9.1856H8.99522Z"
                fill="white"
            />
            <path
                d="M12.2045 6.41589H14.8065C15.5198 6.41589 16.0864 6.62573 16.4641 6.98243C16.7788 7.29718 16.9467 7.73782 16.9467 8.28337V8.30435C16.9467 9.22764 16.4431 9.79413 15.7297 10.0669L17.1146 12.1022H15.6457L14.4288 10.2768H13.4426V12.1022H12.2045V6.41589ZM14.7225 9.1856C15.331 9.1856 15.6877 8.87089 15.6877 8.38828V8.3673C15.6877 7.82174 15.3101 7.54897 14.7015 7.54897H13.4635V9.1856H14.7225Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id={`paint0_linear_${id}`}
                    x1="14.29"
                    y1="11.3096"
                    x2="17.975"
                    y2="1.92972"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.04937" stopColor="#219E89" />
                    <stop offset="0.27923" stopColor="#21BD89" />
                    <stop offset="0.75337" stopColor="#6EDD88" />
                    <stop offset="1" stopColor="#71DE88" />
                </linearGradient>
                <linearGradient
                    id={`paint1_linear_${id}`}
                    x1="17.3975"
                    y1="1.22403"
                    x2="14.9333"
                    y2="13.3856"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#5EF789" />
                    <stop offset="0.1634" stopColor="#21D789" />
                    <stop offset="0.50492" stopColor="#0EA67B" />
                    <stop offset="0.98215" stopColor="#21D789" />
                </linearGradient>
                <linearGradient
                    id={`paint2_linear_${id}`}
                    x1="10.3258"
                    y1="10.1623"
                    x2="18.584"
                    y2="-1.15104"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.38956" stopColor="#5EF789" />
                    <stop offset="0.63623" stopColor="#21D789" />
                    <stop offset="0.92822" stopColor="#0EA67B" />
                </linearGradient>
                <linearGradient
                    id={`paint3_linear_${id}`}
                    x1="20.4156"
                    y1="5.82197"
                    x2="8.09127"
                    y2="23.5344"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.24437" stopColor="#21D789" />
                    <stop offset="0.89126" stopColor="#FDB60D" />
                </linearGradient>
                <linearGradient
                    id={`paint4_linear_${id}`}
                    x1="24.3704"
                    y1="4.64569"
                    x2="11.3698"
                    y2="23.33"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#21D789" />
                    <stop offset="1" stopColor="#FDB60D" />
                </linearGradient>
                <linearGradient
                    id={`paint5_linear_${id}`}
                    x1="19.7975"
                    y1="16.1421"
                    x2="19.941"
                    y2="12.4576"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.06498" stopColor="#037F5C" />
                    <stop offset="0.89819" stopColor="#038E5C" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id={`paint6_linear_${id}`}
                    x1="17.2154"
                    y1="12.6364"
                    x2="4.24807"
                    y2="22.6313"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#21BD89" />
                    <stop offset="0.73314" stopColor="#FDB60D" />
                </linearGradient>
                <linearGradient
                    id={`paint7_linear_${id}`}
                    x1="11.3905"
                    y1="1.54846"
                    x2="5.43078"
                    y2="20.4097"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FE2857" />
                    <stop offset="1" stopColor="#FDB60D" />
                </linearGradient>
                <linearGradient
                    id={`paint8_linear_${id}`}
                    x1="17.6521"
                    y1="0.43473"
                    x2="6.27737"
                    y2="22.7541"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.1207" stopColor="#FD7430" />
                    <stop offset="0.25438" stopColor="#FDB60D" />
                    <stop offset="0.53455" stopColor="#FE2857" />
                    <stop offset="0.91392" stopColor="#FDB60D" />
                </linearGradient>
                <linearGradient
                    id={`paint9_linear_${id}`}
                    x1="4.78899"
                    y1="4.36589"
                    x2="12.111"
                    y2="0.942642"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.21599" stopColor="#BE0059" />
                    <stop offset="0.88355" stopColor="#FE2857" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id={`paint10_linear_${id}`}
                    x1="15.195"
                    y1="6.60472"
                    x2="13.4105"
                    y2="2.43117"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.45951" stopColor="#FE2857" />
                    <stop offset="0.85318" stopColor="#FDB60D" />
                    <stop offset="1" stopColor="#FDFFA1" />
                </linearGradient>
                <linearGradient
                    id={`paint11_linear_${id}`}
                    x1="15.6766"
                    y1="2.53519"
                    x2="2.00861"
                    y2="20.4911"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.27215" stopColor="#FE2857" />
                    <stop offset="1" stopColor="#FDB60D" />
                </linearGradient>
                <linearGradient
                    id={`paint12_linear_${id}`}
                    x1="14.4189"
                    y1="21.463"
                    x2="6.17141"
                    y2="12.2085"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.3899" stopColor="#FDD468" />
                    <stop offset="0.97479" stopColor="#FDB60D" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id={`paint13_linear_${id}`}
                    x1="8.60954"
                    y1="14.7294"
                    x2="0.497015"
                    y2="11.5487"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.34967" stopColor="#FDB60D" stopOpacity="0" />
                    <stop offset="0.98508" stopColor="#FDFFA1" />
                </linearGradient>
                <linearGradient
                    id={`paint14_linear_${id}`}
                    x1="8.226"
                    y1="1.35488"
                    x2="4.22526"
                    y2="14.0166"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.02988" stopColor="#FF7F39" />
                    <stop offset="0.1294" stopColor="#FE2857" />
                    <stop offset="1" stopColor="#FDB60D" />
                </linearGradient>
                <linearGradient
                    id={`paint15_linear_${id}`}
                    x1="10.8376"
                    y1="15.0229"
                    x2="16.4816"
                    y2="10.4506"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.06498" stopColor="#037F5C" />
                    <stop offset="0.89819" stopColor="#038E5C" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id={`paint16_linear_${id}`}
                    x1="4.39527"
                    y1="4.39527"
                    x2="18.2815"
                    y2="18.2815"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.028481" stopColor="#5A1F3A" />
                    <stop offset="0.079756" stopColor="#4E1B32" />
                    <stop offset="0.2774" stopColor="#260D18" />
                    <stop offset="0.3795" stopColor="#16080E" />
                    <stop offset="0.3907" stopColor="#15080E" />
                    <stop offset="0.6833" stopColor="#060204" />
                    <stop offset="0.9138" />
                </linearGradient>
                <linearGradient
                    id={`paint17_linear_${id}`}
                    x1="12.0378"
                    y1="13.6674"
                    x2="15.503"
                    y2="3.98073"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.04937" stopColor="#219E89" stopOpacity="0" />
                    <stop offset="0.82237" stopColor="#6EDD88" />
                    <stop offset="1" stopColor="#71DE88" />
                </linearGradient>
                <linearGradient
                    id={`paint18_linear_${id}`}
                    x1="14.5579"
                    y1="20.5584"
                    x2="27.8279"
                    y2="3.46884"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#21D789" stopOpacity="0" />
                    <stop offset="1" stopColor="#FDB60D" />
                </linearGradient>
                <linearGradient
                    id={`paint19_linear_${id}`}
                    x1="5.0288"
                    y1="1.30311"
                    x2="11.9603"
                    y2="13.9573"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FE2857" />
                    <stop offset="1" stopColor="#FDB60D" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
